import Vue from 'vue';
import Vuex from 'vuex';
import auth from './auth';
import order from './order';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    program: localStorage.getItem('program'),
    staffName: localStorage.getItem('staffName'),
    staffId: localStorage.getItem('staffId'),
    userLicence: localStorage.getItem('userLicence'),
  },
  mutations: {
    SET_PROGRAM(state, value) {
      let program = value.substring(0, 3);
      state.program = program;
      localStorage.setItem('program', program);
    },
    SET_STAFFNAME(state, value) {
      state.staffName = value;
      localStorage.setItem('staffName', value);
    },
    SET_STAFFID(state, value) {
      state.staffId = value;
      localStorage.setItem('staffId', value);
    },
  },
  actions: {
    setProgram(context, value) {
      context.commit('SET_PROGRAM', value.params.program);
    },
    setStaffName(context, value) {
      if (value.params.staffName !== undefined) {
        context.commit('SET_STAFFNAME', value.params.staffName);
      } else {
        context.commit('SET_STAFFNAME', false);
      }
    },
    setStaffId(context, value) {
      if (value.params.staffId !== undefined) {
        context.commit('SET_STAFFID', value.params.staffId);
      } else {
        context.commit('SET_STAFFID', false);
      }
    },
  },
  modules: {
    auth,
    order,
  },
  getters: {
    getProgram(state) {
      return state.program;
    },
    staffName(state) {
      return state.staffName;
    },
    staffId(state) {
      return state.staffId;
    },
  },
});
